import { createSlice } from "@reduxjs/toolkit";
import { IDashboardSlice } from "../../models/user/dashboard/Dashboard";

import {
  GetPoliciesData,
  getClaimsData,
  GetClaimTransactions,
  GetDownloadIdCard,
  GetDownloadPremiumCertificate,
  GetClaimTransactionDocumentContent,
} from "./DashboardAction";

const initialState: IDashboardSlice = {
  policiesData: null,
  claimsData: null,
  carrierClaimStatus: "",
  initiatedDate: "",
  carrierPolicyNo: "",
  claimDescription: "",
  updateDate: "",
  claimTransactions: [],
  claimDocuments: [],
  claimTransactionDocumentContent: null,
  downloadIdCardContent: null,
};

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    setClaimsData: (state, { payload }) => {
      state.claimsData = payload;
    },
    clearClaimsData: (state) => {
      state.claimsData = null;
      state.claimTransactions = [];
      state.claimDocuments = [];
      state.carrierClaimStatus = "";
      state.initiatedDate = "";
      state.carrierPolicyNo = "";
      state.claimDescription = "";
      state.updateDate = "";
      state.claimTransactionDocumentContent = null;
    },
    resetDashboardState: (state) => {
      // Reset all dashboard state to initial values
      state.policiesData = null;
      state.claimsData = null;
      state.carrierClaimStatus = "";
      state.initiatedDate = "";
      state.carrierPolicyNo = "";
      state.claimDescription = "";
      state.updateDate = "";
      state.claimTransactions = [];
      state.claimDocuments = [];
      state.claimTransactionDocumentContent = null;
      state.downloadIdCardContent = null;
    },
    setClaimTransactionDocumentContent: (state, { payload }) => {
      state.claimTransactionDocumentContent = payload;
    },
    setDownloadIdCardContent: (state, { payload }) => {
      state.downloadIdCardContent = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetPoliciesData.fulfilled, (state, { payload }) => {
      if (payload.status === "SUCCESS") {
        state.policiesData = payload.data;
      }
    });

    builder.addCase(getClaimsData.fulfilled, (state, { payload }) => {
      if (payload.status === "SUCCESS") {
        state.claimsData = payload.data;
      }
    });
    builder.addCase(GetClaimTransactions.fulfilled, (state, { payload }) => {
      if (payload.status === "SUCCESS") {
        const { claimTransactionHistory, claimDocuments, carrierClaimStatus, initiatedDate, carrierPolicyNo, claimDescription, updateDate } = payload.data;
        state.claimTransactions = claimTransactionHistory || [];
        state.claimDocuments = claimDocuments || [];
        state.carrierClaimStatus = carrierClaimStatus || "";
        state.initiatedDate = initiatedDate || "";
        state.carrierPolicyNo = carrierPolicyNo || "";
        state.claimDescription = claimDescription || "";
        state.updateDate = updateDate || "";
      } else {
        state.claimTransactions = [];
        state.claimDocuments = [];
        state.carrierClaimStatus = "";
        state.initiatedDate = "";
        state.carrierPolicyNo = "";
        state.claimDescription = "";
        state.updateDate = "";
      }
    });
    builder.addCase(
      GetClaimTransactionDocumentContent.fulfilled,
      (state, { payload }) => {
        state.claimTransactionDocumentContent = payload;
      }
    );
    builder.addCase(GetDownloadIdCard.fulfilled, (state, { payload }) => {
      state.downloadIdCardContent =
        payload && payload.status !== "FAIL" ? payload : null;
    });
    builder.addCase(GetDownloadPremiumCertificate.fulfilled, (state, { payload }) => {
      state.downloadIdCardContent =
        payload && payload.status !== "FAIL" ? payload : null;
    });
  },
});

export default DashboardSlice.reducer;
export const {
  setClaimsData,
  clearClaimsData,
  resetDashboardState,
  setClaimTransactionDocumentContent,
  setDownloadIdCardContent,
} = DashboardSlice.actions;
